import { LatitudeLongitude, isUndefined } from '@aloft/toolkit-shared';
import { distance, point } from '@turf/turf';

export function proximityMiles(
  p1: Partial<LatitudeLongitude>,
  p2: Partial<LatitudeLongitude>,
): number | undefined {
  const { longitude: p1lon, latitude: p1lat } = p1;
  const { longitude: p2lon, latitude: p2lat } = p2;

  if ([p1lon, p1lat, p2lon, p2lat].some(isUndefined)) return undefined;
  return distance(point([p1lon!, p1lat!]), point([p2lon!, p2lat!]), { units: 'miles' });
}
